/** @jsxImportSource @emotion/react */
import { getGoogleEmailWithAccessToken } from "apis/auth/google";

export const openGooglePopup = (callback?: (email: string, accessToken: string) => void) => {
  const scopes = ["https://www.googleapis.com/auth/userinfo.profile", "https://www.googleapis.com/auth/userinfo.email"];
  const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${
    process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID
  }&redirect_uri=${process.env.REACT_APP_WEB_URL}/google/redirect/sign-up&scope=${scopes.join(
    " "
  )}&access_type=offline`;

  const popup = window.open(url, "sign-up", "width=600,height=800");

  // message 이벤트 리스너는 팝업 창이 열리자마자 추가
  window.addEventListener("message", async (event) => {
    const { success, googleAccessToken } = event.data;

    if (success && googleAccessToken) {
      const res = await getGoogleEmailWithAccessToken(googleAccessToken);
      if (res?.email) {
        callback?.(res.email, googleAccessToken);
      } else {
        alert("데이터를 불러오는데 실패하였습니다.");
      }
    }
  });

  const timer = setInterval(() => {
    try {
      if (popup?.closed) {
        clearInterval(timer);
      }
    } catch (error) {
      console.error("Error detecting popup closure", error);
    }
  }, 1000);
};
